import { useEffect, useRef } from 'react';

const MARKER = 'wa_modal_layer';

export const useModalBackButton = (isOpen, onClose) => {
    const pushedRef = useRef(false);
    const onCloseRef = useRef(onClose);

    useEffect(() => {
        onCloseRef.current = onClose;
    }, [onClose]);

    useEffect(() => {
        if (typeof window === 'undefined') return undefined;

        if (!isOpen) {
            if (pushedRef.current && window.history.state?.[MARKER]) {
                pushedRef.current = false;
                window.history.back();
            } else {
                pushedRef.current = false;
            }
            return undefined;
        }

        window.history.pushState(
            { ...(window.history.state || {}), [MARKER]: true },
            '',
        );
        pushedRef.current = true;

        const onPopState = () => {
            pushedRef.current = false;
            onCloseRef.current?.();
        };

        window.addEventListener('popstate', onPopState);
        return () => {
            window.removeEventListener('popstate', onPopState);
        };
    }, [isOpen]);
};
